import React from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";
import NotFound from "./pages/error/NotFound";
import Home from "./pages/home";
import Contact from "./pages/contact";
import About from "./pages/about";
import Unique from "./pages/unique";
// import LoadingMain from "./pages/main";

import Peer from "./pages/services/PeerToPeer";
import Web3 from "./pages/services/Web3";
import Smart from "./pages/services/smartContract";
import Market from "./pages/services/Marketplace";
import FullNFT from "./pages/services/fullNFT";
import FullScales from "./pages/services/fullScale";
import LoadingMain from "./pages/main";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route exact path="/" element={<LoadingMain />} />
        <Route exact path="/home" element={<Home />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/unique" element={<Unique />} />;
        <Route exact path="/web3" element={<Web3 />} />
        <Route exact path="/Peer" element={<Peer />} />
        <Route exact path="/smartContract" element={<Smart />} />
        <Route exact path="/fullNFT" element={<FullNFT />} />
        <Route exact path="/fullScale" element={<FullScales />} />
        <Route exact path="/market" element={<Market />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
